import { ActivityTypeOption, FeedbackTypeOption, ActivityColor } from '../types';

export const getActivityTypeOptions = (): ActivityTypeOption[] => [
  { value: "walk", label: "Walk", icon: "🚶" },
  { value: "feed", label: "Feed", icon: "🍽️" },
  { value: "medicine", label: "Medicine", icon: "💊" },
  { value: "grooming", label: "Grooming", icon: "✂️" },
  { value: "play", label: "Play", icon: "🎾" },
  { value: "training", label: "Training", icon: "🎓" },
  { value: "custom", label: "Custom", icon: "⚡" }
];

export const getFeedbackTypeOptions = (): FeedbackTypeOption[] => [
  { value: "poop_rating", label: "Poop Rating (1-5 stars)" },
  { value: "food_info", label: "Food Information" },
  { value: "medicine_info", label: "Medicine Information" },
  { value: "grooming_info", label: "Grooming Information" },
  { value: "play_info", label: "Play Information" },
  { value: "training_info", label: "Training Information" },
  { value: "duration", label: "Duration" },
  { value: "location", label: "Location" },
  { value: "rating", label: "Rating (1-5 stars)" },
  { value: "notes", label: "Notes" }
];

export const getCardStyle = (color: ActivityColor): string => {
  const styles: Record<ActivityColor, string> = {
    blue: "bg-gradient-to-br from-blue-400 to-blue-600",
    green: "bg-gradient-to-br from-green-400 to-green-600",
    purple: "bg-gradient-to-br from-purple-400 to-purple-600",
    pink: "bg-gradient-to-br from-pink-400 to-pink-600",
    orange: "bg-gradient-to-br from-orange-400 to-orange-600",
    teal: "bg-gradient-to-br from-teal-400 to-teal-600"
  };
  return styles[color] || styles.blue;
};

export const formatTimeLeft = (minutes: number): string => {
  if (minutes <= 0) return "00:00";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};